export const DATE_FORMAT = { en: "DD.MM.YYYY", de: "DD.MM.YYYY" };

export const TIME_FORMAT = { en: "h:mm A", de: " HH:mm [Uhr]" };

export const DATE_TIME_FORMAT = {
    en: `${DATE_FORMAT.en}, ${TIME_FORMAT.en}`,
    de: `${DATE_FORMAT.de}, ${TIME_FORMAT.de}`,
};
